
<c-card *transloco="let t">
    <c-card-body>
  
        <h1>{{ t('Welcome to the Lone Worker Safety Awards') }}</h1>
  
        <p>{{ t('Keeping your workers') }} <b>{{ t('safe') }}</b> {{ t('is important to us.') }} <b>{{ t('Staying safe') }}</b> {{ t('is very important to') }} <b>{{ t('your workers and your company') }}</b>! {{ t("But just because something is important, doesn’t mean it can’t be") }} <b>{{ t('fun') }}</b> {{ t('too') }}!</p>
  
        <p>{{ t("OK Alone's") }} <i class="fa fa-trophy gold" aria-hidden="true"></i> {{ t('Safety Awards offer an engaging way to') }} <b>{{ t('stay safe') }}</b>, {{ t('while using the lone worker system to') }} <b>{{ t('compete') }}</b> {{ t('with colleagues and companies across the world. The program recognises OK Alone feature usage or when a worker completes a safe shift and rewards them with badges, points and rankings.') }}</p>
  
        <p>{{ t('Who will be the') }} <b>#1 {{ t('WORKER') }}</b> {{ t('in your company, your country or the world?!') }}</p>

  
        <div class="alert alert-info" role="alert">
          <i class="fa-solid fa-circle-info"></i> {{ t('This is a Demo Safety Awards section. Once your account starts using OK Alone for a month or more your own Safety Awards with be created.') }}
        </div>
  
  
  
        <div class="row">
          <div class="col">
  
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link"  aria-current="page"  (click)="page='home'" [class.active]="page=='home'"><i class="fa-solid fa-house"></i> {{ t('Awards Home') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"   data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="Safety Champions are available in live accounts."><i class="fa-solid fa-trophy"></i> {{ t('Safety Champions') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"   data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="Certificates are available in live accounts." ><i class="fa-solid fa-award"></i> {{ t('Certificates') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"   data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="Report Cards are available in live accounts." ><i class="fa-solid fa-file-circle-check"></i> {{ t('Report Cards') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"   data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="Worker Rankings are available in live accounts." ><i class="fa-solid fa-users"></i> {{ t('Worker Rankings') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"   data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="Company Rankings are available in live accounts." ><i class="fa-solid fa-building"></i> {{ t('Company Rankings') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  (click)="page='examples'" [class.active]="page=='examples'"><i class="fa-solid fa-star-half-stroke"></i> {{ t('Award Examples') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  (click)="page='faq'" [class.active]="page=='faq'"><i class="fa-solid fa-circle-question"></i> {{ t('FAQ') }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="mt-3">

    <ng-container *ngIf="page == 'home'" >

        <div class="row">
            <div class="col-12 col-md-6">
              <c-card class="mb-3">
                <c-card-header>
                  <b> {{ t('Top Safe Workers for') }} {{month}} </b>
                </c-card-header>
                <c-card-body>
        
        
                    <table
                    [hover]="true"
                    [responsive]="true"
                    [striped]="true"
                    align="middle"
                    cTable
                    class="mb-0"
                    >
                    <tr>
                        <td class="score">
                          <b>
                                      <i class="fa fa-trophy gold" aria-hidden="true"></i>
                           
                          1st - 80.00</b>
                        </td>
                        <td>Sarah Lane</td>
                        <td>
                                    <img src="https://okalone.net/awards/badges/ranking/place-1.svg"  class="badge-img p-0 m-0" width="35px"  alt="1st Worker of the Month" title="1st Worker of the Month">
                                    <img src="https://okalone.net/awards/badges/ranking/group-1.svg"  class="badge-img p-0 m-0" width="35px"  alt="1st Group of the Month - Peter's Group" title="1st Group of the Month - Peter's Group">
                                    <img src="https://okalone.net/awards/badges/feature/app-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="App User" title="App User">
                                    <img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Started the Shift" title="Started the Shift">
                                    <img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Checked In" title="Checked In">
                                    <img src="https://okalone.net/awards/badges/feature/gps-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="GPS User" title="GPS User">
                                    <img src="https://okalone.net/awards/badges/feature/message-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Message Sent" title="Message Sent">
                                    <img src="https://okalone.net/awards/badges/feature/sms-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Sms User" title="Sms User">
                                </td>
                      
                      </tr>
                
                              <tr>
                        <td class="score">
                          <b>
                                      <i class="fa fa-trophy silver" aria-hidden="true"></i>
                           
                          2nd - 68.60</b>
                        </td>
                        <td>Emily Davis</td>
                        <td>
                                    <img src="https://okalone.net/awards/badges/ranking/place-2.svg"  class="badge-img p-0 m-0" width="35px"  alt="2nd Worker of the Month" title="2nd Worker of the Month">
                                    <img src="https://okalone.net/awards/badges/feature/app-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="App User" title="App User">
                                    <img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Started the Shift" title="Started the Shift">
                                    <img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Checked In" title="Checked In">
                                    <img src="https://okalone.net/awards/badges/feature/gps-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="GPS User" title="GPS User">
                                    <img src="https://okalone.net/awards/badges/feature/whatsapp-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Whatsapp User" title="Whatsapp User">
                                </td>
                      
                      </tr>
                
                              <tr>
                        <td class="score">
                          <b>
                                      <i class="fa fa-trophy bronze" aria-hidden="true"></i>
                           
                          3rd - 64.60</b>
                        </td>
                        <td>Heather Andrews</td>
                        <td>
                                    <img src="https://okalone.net/awards/badges/ranking/place-3.svg"  class="badge-img p-0 m-0" width="35px"  alt="3rd Worker of the Month" title="3rd Worker of the Month">
                                    <img src="https://okalone.net/awards/badges/feature/app-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="App User" title="App User">
                                    <img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Started the Shift" title="Started the Shift">
                                    <img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Checked In" title="Checked In">
                                    <img src="https://okalone.net/awards/badges/feature/gps-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="GPS User" title="GPS User">
                                    <img src="https://okalone.net/awards/badges/feature/whatsapp-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Whatsapp User" title="Whatsapp User">
                                </td>
                      
                      </tr>
                
                              <tr>
                        <td class="score">
                          <b>
                                      &nbsp;&nbsp;&nbsp;&nbsp;
                           
                          4th - 61.77</b>
                        </td>
                        <td>Dave Smith</td>
                        <td>
                                    <img src="https://okalone.net/awards/badges/feature/app-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="App User" title="App User">
                                    <img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Started the Shift" title="Started the Shift">
                                    <img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Checked In" title="Checked In">
                                    <img src="https://okalone.net/awards/badges/feature/gps-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="GPS User" title="GPS User">
                                    <img src="https://okalone.net/awards/badges/feature/message-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Message Sent" title="Message Sent">
                                    <img src="https://okalone.net/awards/badges/feature/sms-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Sms User" title="Sms User">
                                    <img src="https://okalone.net/awards/badges/feature/phonecall-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Phonecall User" title="Phonecall User">
                                    <img src="https://okalone.net/awards/badges/feature/whatsapp-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Whatsapp User" title="Whatsapp User">
                                </td>
                      
                      </tr>
                
                              <tr>
                        <td class="score">
                          <b>
                                      &nbsp;&nbsp;&nbsp;&nbsp;
                           
                          5th - 43.40</b>
                        </td>
                        <td>Andy Smith</td>
                        <td>
                                    <img src="https://okalone.net/awards/badges/feature/app-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="App User" title="App User">
                                    <img src="https://okalone.net/awards/badges/feature/shift-start-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Started the Shift" title="Started the Shift">
                                    <img src="https://okalone.net/awards/badges/feature/checked-in-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Checked In" title="Checked In">
                                    <img src="https://okalone.net/awards/badges/feature/whatsapp-badge.svg"  class="badge-img p-0 m-0" width="35px"  alt="Whatsapp User" title="Whatsapp User">
                                </td>
                      
                      </tr>
                    </table>
        
                </c-card-body>
        
              </c-card>
        
              <c-card class="mb-2">
                <c-card-header><b> {{ t('Latest Company Certificates') }}</b></c-card-header>
                <c-card-body class="report-container">
                  <div class="row">
                    <div class="col-12 col-lg-6" >
                      <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/certificate/1862-31-null-rjd1n04tU1xN3U.png" class="img-fluid img-thumbnail">
                    </div>
                    <div class="col-12 col-lg-6" >
                      <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/jun2020/certificate/1660-31-null-js5zzgvW8UH42z.png" class="img-fluid img-thumbnail">
                    </div>
                  </div>
                </c-card-body>
              </c-card>
        
              <c-card class="mb-2">
                <c-card-header><b> {{ t('Worker Report Cards') }}</b></c-card-header>
                <c-card-body class="report-container">
                    <p>Certificates are issued every month to the top 10 workers in each company, country and the world.</p>

                    <p>The certificates can be shared online, by email or printed out for the office wall or the fridge at home!</p>
                  <div class="row">
                    <div class="col-12 col-lg-6">
                    <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/reportcard/2306-31-425-qKgufCGttgrDT1.png" class="img-fluid">
                  </div>
                  <div class="col-12 col-lg-6">
                  <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/reportcard/2313-31-11500-9w85eQ8G7UvrPI.png" class="img-fluid">
                </div>
                <div class="col-12 col-lg-6">
                <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/reportcard/2309-31-7726-z7qIs6SVCyvkTV.png" class="img-fluid">
                </div>
                </div>
                </c-card-body>
              </c-card>
        
        
            </div>
        
            <div class="col-12 col-md-6">
        
              <c-card class="mb-4">
                <c-card-header><b> {{ t('Company Results for') }} {{month}}</b></c-card-header>
                <c-card-body>
                  <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/reportcard/1830-31-null-pbb6EDOpY5l21i.png" class="img-fluid">
                </c-card-body>
              </c-card>
        
              <c-card class="mb-2" >
                <c-card-header><b> {{ t('Latest Worker Certificates') }}</b></c-card-header>
                <c-card-body class="report-container">
                  <div class="row">
                    <div class="col-12 col-lg-6">
                    <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/certificate/1881-31-7726-6UEtS2pZOyRMQx.png" class="img-fluid">
                  </div>
                  <div class="col-12 col-lg-6">
                  <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/certificate/1879-31-425-z8IbqI5JTgqocV.png" class="img-fluid">
                </div>
                <div class="col-12 col-lg-6">
                <img src="https://okalone-awards.s3.ca-central-1.amazonaws.com/sep2020/certificate/1880-31-11500-86VbYCeptHtIRv.png" class="img-fluid">
                </div></div>
                </c-card-body>
              </c-card>
        
        
            <div class="card">
              <div class="card-body">
              <p>{{ t("Don't want Safety Awards on your account? Please email us at") }} <a href="customer.support@ok-alone.com" target="new">customer.support&#64;ok-alone.com</a> {{ t('and we can disable it for you.') }}</p>
              </div>
            </div>
        
            </div>
          </div>

    </ng-container>

    
    <ng-container *ngIf="page == 'certificates'" ></ng-container>
    <ng-container *ngIf="page == 'champions'" ></ng-container>
    <ng-container *ngIf="page == 'reportcards'" ></ng-container>
    <ng-container *ngIf="page == 'companyrankings'" ></ng-container>
    <ng-container *ngIf="page == 'workerrankings'" ></ng-container>
  
    <app-awards-examples *ngIf="page == 'examples'" ></app-awards-examples>
    <app-awards-faq *ngIf="page == 'faq'"></app-awards-faq>
  

    </div>
  
  </c-card-body>
  </c-card>
  